const getCurrentTimeStamp = () => {
    return `${getDate()} ${getTime()}`;
};

const addTimes = (times = []) => {
    const z = (n) => (n < 10 ? "0" : "") + n;

    let hour = 0;
    let minute = 0;
    let second = 0;
    for (const time of times) {
        const splited = time.split(":");
        hour += parseInt(splited[0]);
        minute += parseInt(splited[1]);
        second += parseInt(splited[2]);
    }
    const seconds = second % 60;
    const minutes = parseInt(minute % 60) + parseInt(second / 60);
    const hours = hour + parseInt(minute / 60);

    return z(hours) + ":" + z(minutes) + ":" + z(seconds);
};

const getPasswordLinkExpiryTime = () => {
    return `${getDate()} ${addTimes([getTime(), "00:15:00"])}`;
};

const getDate = () => {
    const now = new Date();
    let day = now.getDate();
    let month = now.getMonth() + 1;

    if (day < 10) day = `0${day}`;
    if (month < 10) month = `0${month}`;
    return `${now.getFullYear()}-${month}-${day}`;
};
const getTimeFromTable = (date) => {
    let options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    };
    const modifiedDate = date.replace("T", " ");
    return new Date(`${modifiedDate} UTC`).toLocaleString("en-us", options);
};
const getTime = (val) => {
    const now = new Date();
    let min = now.getMinutes();
    let sec = now.getSeconds();
    let hour = now.getHours();

    if (min < 10) min = `0${min}`;
    if (sec < 10) sec = `0${sec}`;
    if (hour < 10) hour = `0${hour}`;

    if (val) min += val;

    return `${hour}:${min}:${sec}`;
};

export default {
    getCurrentTimeStamp,
    getPasswordLinkExpiryTime,
    getDate,
    getTime,
    getTimeFromTable,
};
